export const defaultPageLimits = [5, 10, 20, 25, 50, 100]

export const tableStringLimit = 40
